import React from "react";

export enum SubscriptionFeatures {
  DreamHouse = "Dream House",
  LuxuryCars = "Luxury Cars",
  DreamCars = "Dream Cars",
  LifestylePrizes = "Pick Your Prize",
  InstantWins = "Instant Wins",
  PassExclusiveComps = "Pass EXCLUSIVE Comps",
}

export type SubscriptionCustomFeature = {
  type: SubscriptionFeatures;
  image: string;
  entries: number;
  multiplier: number | string;
  text: React.ReactNode;
};

export type OnCloseReason = "successSubmit" | "closeButtonClicked";
